import { useCallback, useState } from "react";

import { FUEL_PRICE_WORKBENCH_TABS, PRICE_SNAPSHOT_ROLE } from "../constants";

const createEmptyPeriodOverlay = () => ({
    open: false,
    periodId: null,
});

const createEmptyPriceInputState = () => ({
    open: false,
    periodId: null,
    snapshotRole: PRICE_SNAPSHOT_ROLE.INTERNAL_REFERENCE,
});

function useFuelPriceWorkbenchViewState(initialActiveTab = FUEL_PRICE_WORKBENCH_TABS.WORKBENCH) {
    const [activeTab, setActiveTab] = useState(initialActiveTab);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [priceInputState, setPriceInputState] = useState(createEmptyPriceInputState);
    const [disputeState, setDisputeState] = useState(createEmptyPeriodOverlay);
    const [comparisonState, setComparisonState] = useState(createEmptyPeriodOverlay);
    const [detailState, setDetailState] = useState(createEmptyPeriodOverlay);

    const openCreateModal = useCallback(() => setCreateModalOpen(true), []);
    const closeCreateModal = useCallback(() => setCreateModalOpen(false), []);

    const openPriceInput = useCallback((snapshotRole, periodId) => {
        setPriceInputState({
            open: true,
            periodId,
            snapshotRole,
        });
    }, []);

    const closePriceInput = useCallback(() => {
        setPriceInputState(createEmptyPriceInputState());
    }, []);

    const openDispute = useCallback((periodId) => {
        setDisputeState({ open: true, periodId });
    }, []);

    const closeDispute = useCallback(() => {
        setDisputeState(createEmptyPeriodOverlay());
    }, []);

    const openComparison = useCallback((periodId) => {
        setComparisonState({ open: true, periodId });
    }, []);

    const closeComparison = useCallback(() => {
        setComparisonState(createEmptyPeriodOverlay());
    }, []);

    const openDetail = useCallback((periodId) => {
        setDetailState({ open: true, periodId });
    }, []);

    const closeDetail = useCallback(() => {
        setDetailState(createEmptyPeriodOverlay());
    }, []);

    return {
        activeTab,
        setActiveTab,
        createModalOpen,
        openCreateModal,
        closeCreateModal,
        priceInputState,
        openPriceInput,
        closePriceInput,
        disputeState,
        openDispute,
        closeDispute,
        comparisonState,
        openComparison,
        closeComparison,
        detailState,
        openDetail,
        closeDetail,
    };
}

export default useFuelPriceWorkbenchViewState;
